mutation passwordResetClaim($token: String!, $password: String!) {
  passwordResetClaim(token: $token, password: $password) {
    token
    userId
  }
}
